import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';

const { ORGANIZATION_REPORTS } = API.END_POINTS.API;

const RECEIVE_CAMPAIGN_ACHIEVEMENTS = 'campaignAchievements/RECEIVE_CAMPAIGN_ACHIEVEMENTS';
const RECEIVE_CAMPAIGN_STATS = 'campaignAchievements/RECEIVE_CAMPAIGN_STATS';
const RESET = 'campaignAchievements/RESET';
const LOADING = 'campaignAchievements/LOADING';

const initialState = {
  achievements: [],
  stats: [],
  isLoading: true
};

export function resetCampaignAchievements() {
  return {
    type: RESET,
    payload: {}
  };
}

function receiveCampaignAchievements(data) {
  return {
    type: RECEIVE_CAMPAIGN_ACHIEVEMENTS,
    payload: {
      data
    }
  };
}

function receiveCampaignStats(data) {
  return {
    type: RECEIVE_CAMPAIGN_STATS,
    payload: {
      data
    }
  };
}

function setLoadingStatus(status) {
  return {
    type: LOADING,
    payload: {
      status
    }
  };
}


export function fetchCampaignAchievements(organizationId) {
  const url = `${ORGANIZATION_REPORTS}/${organizationId}/report`;

  return (dispatch) => {
    dispatch(setLoadingStatus(true));

    return get(url)
      .then((response) => {
        const report = response.data;
        dispatch(receiveCampaignAchievements(report.achievements));
        dispatch(receiveCampaignStats(report.stats));
        dispatch(setLoadingStatus(false));
      })
      .catch(() => {
        dispatch(receiveCampaignAchievements([]));
        dispatch(receiveCampaignStats([]));
        dispatch(setLoadingStatus(false));
      });
  };
}

export default createReducer('campaignAchievements', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [RECEIVE_CAMPAIGN_ACHIEVEMENTS]: (state, { data }) => ({
    ...state,
    achievements: data
  }),
  [RECEIVE_CAMPAIGN_STATS]: (state, { data }) => ({
    ...state,
    stats: data
  }),
  [LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  })
});
